// pubnubKeys.js

// Replace these with your actual PubNub keys
export const subscribeKey = 'pub-c-b9d72cc7-0ba1-437d-82da-f0f505fb9dd5';
export const publishKey = 'sub-c-77db001c-3ea6-4aab-8750-c22ef7cc7b3e';
